import type { FaireProductEntity } from "../../entity_types/product";

export const p_qsmqm9z8e9: FaireProductEntity = {
  token: "p_qsmqm9z8e9",
  type: "product",
  name: 'Puka Shell Necklace - Round Seashell Choker - Sizes 14"-20"',
  brandToken: "b_kqast86cfn",
  brandName: "Natalia",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3cd7c7b0d5cd24183d6760f722965abcca4f6a0a4530211f9d11fc52bfd7c3e0.png",
  priceDollars: 8,
  description: "",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T02:38:59.750Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
